<p class="mb-0 range-slider-label">{{ useCommas ? (rangeSlider.minValue | number) : rangeSlider.minValue}} -
  {{ useCommas ? (rangeSlider.maxValue | number) : rangeSlider.maxValue}} {{rangeSlider.unit}}</p>
<div class="custom-slider">
  <ngx-slider [(value)]="rangeSlider.minValue" [(highValue)]="rangeSlider.maxValue" [options]="options"
    (userChangeEnd)="onUserChangeEnd()"></ngx-slider>
</div>